import React from 'react';
import { Svg } from './iconPrimitives';

/** Line icons for ingredient API `type` — matches BlendJourneyIcons stroke weight */
export function CategoryGlyph({ categoryKey, className, size = 20 }) {
  const c = className;
  switch (categoryKey) {
    case 'tea_leaf':
      return (
        <Svg className={c} size={size}>
          <path d="M6 10h12v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8Z" />
          <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </Svg>
      );
    case 'herb':
      return (
        <Svg className={c} size={size}>
          <path d="M12 3c-2 3-5 4-5 8a5 5 0 0 0 10 0c0-4-3-5-5-8Z" />
          <path d="M12 11v10" />
        </Svg>
      );
    case 'flower':
      return (
        <Svg className={c} size={size}>
          <circle cx="12" cy="12" r="2.5" />
          <path d="M12 6v2M12 16v2M6 12h2M16 12h2M7.76 7.76l1.41 1.41M14.83 14.83l1.41 1.41M7.76 16.24l1.41-1.41M14.83 9.17l1.41-1.41" />
        </Svg>
      );
    case 'spice':
      return (
        <Svg className={c} size={size}>
          <path d="M12 2l1.8 5.5L19 9l-5.2 2.2L12 17l-1.8-5.8L5 9l5.2-1.5L12 2z" />
        </Svg>
      );
    case 'root':
      return (
        <Svg className={c} size={size}>
          <path d="M12 4v4c0 2-3 3-3 6s2 4 3 10c1-6 4-7 3-10s-3-4-3-6V4" />
          <path d="M10 14h4" />
        </Svg>
      );
    case 'fruit':
      return (
        <Svg className={c} size={size}>
          <path d="M12 4c-4 0-7 3-7 7 0 4 3 7 7 7s7-3 7-7c0-4-3-7-7-7Z" />
          <path d="M12 4v-2" />
        </Svg>
      );
    case 'seed':
      return (
        <Svg className={c} size={size}>
          <ellipse cx="12" cy="12" rx="4" ry="6" />
          <path d="M12 6v12" />
        </Svg>
      );
    case 'bark':
      return (
        <Svg className={c} size={size}>
          <path d="M8 4v16M12 4v16M16 4v16M8 8h8M8 14h5" />
        </Svg>
      );
    case 'bud':
      return (
        <Svg className={c} size={size}>
          <path d="M12 3c-3 3-4 6-4 9a4 4 0 0 0 8 0c0-3-1-6-4-9Z" />
          <path d="M12 12v9" />
        </Svg>
      );
    case 'leaf':
      return (
        <Svg className={c} size={size}>
          <path d="M12 3C8 7 6 11 6 15a6 6 0 0 0 12 0c0-4-2-8-6-12Z" />
          <path d="M12 9v12" />
        </Svg>
      );
    case 'peel':
      return (
        <Svg className={c} size={size}>
          <path d="M8 20c4-2 8-8 8-14a8 8 0 0 0-8 8v6Z" />
          <path d="M8 20h8" />
        </Svg>
      );
    case 'mushroom':
      return (
        <Svg className={c} size={size}>
          <path d="M8 12c0-3 2-6 4-6s4 3 4 6" />
          <path d="M6 12h12a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4Z" />
          <path d="M12 12v8" />
        </Svg>
      );
    case 'pod':
      return (
        <Svg className={c} size={size}>
          <path d="M8 8c0-2 2-4 4-4s4 2 4 4v8c0 2-2 4-4 4s-4-2-4-4V8Z" />
          <path d="M12 8v8" />
        </Svg>
      );
    default:
      return (
        <Svg className={c} size={size}>
          <circle cx="12" cy="12" r="8" />
        </Svg>
      );
  }
}
